// extracted by mini-css-extract-plugin
export default {"tooltip":"xvdZMJRKSpG6GgbUFsGZ","holder":"sUOdepgsQQXoMlECelkw","icon":"OLvBz3fK9_RY2CkWL6zg","tip":"bg_H_2MWCrVlH8yq6Rc_"};